import type { Video } from "@/types/video";
import VideoCard from "@/components/feature/VideoCard";
import { videos as allVideos } from "@/mocks/videos";
import { sortVideos } from "@/utils/videoFilters";

interface RelatedVideosProps {
  current: Video;
}

export default function RelatedVideos({ current }: RelatedVideosProps) {
  const sameCategory = sortVideos(
    allVideos.filter((video) => video.category === current.category && video.id !== current.id),
    "hot",
  );
  const others = sortVideos(
    allVideos.filter((video) => video.category !== current.category && video.id !== current.id),
    "hot",
  );
  const related = [...sameCategory, ...others].slice(0, 8);

  return (
    <section className="mt-12">
      <div className="mb-6 flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
          <i className="ri-movie-2-line"></i>
        </span>
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950">相关推荐</h2>
          <p className="text-xs text-foreground-500">根据当前视频分类为你精选的内容</p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {related.map((video) => (
          <VideoCard key={video.id} video={video} />
        ))}
      </div>
    </section>
  );
}